import {
    createStyles,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    makeStyles,
} from "@material-ui/core";
import { Button, DialogCloseIconButton, RelodeTheme, Text } from "../../";
import * as React from "react";

import { NotificationIcon } from "../notifications/notificationIcon";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                top: -256,
            },
            title: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            },
            titleIcon: {
                display: "flex",
                flexDirection: "row",
                alignItems: "start",
                justifyContent: "space-between",
            },
            titleSpacer: {
                width: theme.spacing(6),
            },
            content: {
                padding: "8px 24px 40px 24px",
            },
            icon: {
                fontSize: 56,
                marginTop: 16,
                marginBottom: theme.spacing(2),
            },
            actionButton: {
                marginRight: theme.spacing(2),
                marginBottom: theme.spacing(2),
            },
        }),
    { name: "ReloadConfirmationPrompt" }
);

export const useReloadConfirmation = (cb: (confirmed: boolean) => void) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const classes = useStyles({});
    const openConfirm = () => {
        setIsOpen(true);
    };

    const handleConfirm = (confirmed: boolean) => {
        setIsOpen(false);
        cb(confirmed);
    };

    const Modal = (
        <>
            {isOpen ? (
                <Dialog
                    open={isOpen}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{ className: classes.root }}
                    disableEscapeKeyDown={false}
                    onEscapeKeyDown={() => handleConfirm(false)}
                >
                    <DialogTitle
                        disableTypography={true}
                        className={classes.title}
                    >
                        <div className={classes.titleIcon}>
                            <div className={classes.titleSpacer}></div>
                            <NotificationIcon
                                level="warning"
                                size="large"
                                className={classes.icon}
                            />
                            <DialogCloseIconButton
                                onClick={() => handleConfirm(false)}
                            />
                        </div>
                        <Text variant="h2" align="center">
                            unsaved changes
                        </Text>
                    </DialogTitle>
                    <DialogContent className={classes.content}>
                        <Text variant="body1">
                            You have unsaved changes. You may discard your
                            changes to continue or close this to cancel the
                            operation.
                        </Text>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            size="small"
                            color="secondary"
                            variant="contained"
                            className={classes.actionButton}
                            onClick={() => handleConfirm(true)}
                        >
                            discard
                        </Button>
                    </DialogActions>
                </Dialog>
            ) : null}
        </>
    );

    return [Modal, openConfirm] as [JSX.Element, () => void];
};
